module.exports = __webpack_public_path__ + "static/media/font.757de4c9.svg";